import { Animation, AnimationController } from '@ionic/angular/standalone';

interface TransitionOptions {
  enteringEl: HTMLElement;
  leavingEl: HTMLElement;
  direction: 'forward' | 'back';
  mode?: string;
}

// NOTE: Custom iOS transition without opacity changes to prevent translucent effect
export const customIosTransitionAnimation = (
  _: HTMLElement,
  opts: TransitionOptions
): Animation => {
  const DURATION = 540;
  const EASING = 'cubic-bezier(0.36,0.66,0.04,1)';
  const OPACITY = 1; // NOTE: Always 1 to prevent translucency
  const TRANSFORM_OFFSET = '100%';

  const animationCtrl = new AnimationController();
  const rootTransition = animationCtrl.create();
  const enteringPage = animationCtrl
    .create()
    .addElement(opts.enteringEl)
    .beforeRemoveClass('ion-page-invisible');

  const leavingPage = animationCtrl.create().addElement(opts.leavingEl);

  if (opts.direction === 'forward') {
    enteringPage
      .fromTo('transform', `translateX(${TRANSFORM_OFFSET})`, 'translateX(0)')
      .fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change

    leavingPage
      .fromTo('transform', 'translateX(0)', `translateX(-${TRANSFORM_OFFSET})`)
      .fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change
  } else {
    enteringPage
      .fromTo('transform', `translateX(-${TRANSFORM_OFFSET})`, 'translateX(0)')
      .fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change

    leavingPage
      .fromTo('transform', 'translateX(0)', `translateX(${TRANSFORM_OFFSET})`)
      .fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change
  }

  rootTransition.duration(DURATION).easing(EASING);
  rootTransition.addAnimation([enteringPage, leavingPage]);

  return rootTransition;
};

// NOTE: Custom Material Design (Android) transition without opacity changes
export const customMdTransitionAnimation = (
  _: HTMLElement,
  opts: TransitionOptions
): Animation => {
  const DURATION = 280;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const OPACITY = 1; // NOTE: Always 1 to prevent translucency

  const animationCtrl = new AnimationController();
  const rootTransition = animationCtrl.create();
  const enteringPage = animationCtrl
    .create()
    .addElement(opts.enteringEl)
    .beforeRemoveClass('ion-page-invisible');

  const leavingPage = animationCtrl.create().addElement(opts.leavingEl);

  if (opts.direction === 'forward') {
    enteringPage
      .fromTo('transform', 'translateX(100%)', 'translateX(0)')
      .fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change

    leavingPage.fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change
  } else {
    enteringPage
      .fromTo('transform', 'translateX(-100%)', 'translateX(0)')
      .fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change

    leavingPage
      .fromTo('transform', 'translateX(0)', 'translateX(100%)')
      .fromTo('opacity', OPACITY, OPACITY); // NOTE: No opacity change
  }

  rootTransition.duration(DURATION).easing(EASING);
  rootTransition.addAnimation([enteringPage, leavingPage]);

  return rootTransition;
};
